export default "__VITE_ASSET__BUpFU2C8__"